var _OverlayBox, _CircularProgress;
import React from 'react';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useLocalization } from '@im/react-localization';
import Box from '@mui/material/Box';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function CenterLoader(props) {
  var loaderText = props.loaderText,
    _props$overlay = props.overlay,
    overlay = _props$overlay === void 0 ? true : _props$overlay;
  var _useLocalization = useLocalization(),
    translate = _useLocalization.translate;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [overlay && (_OverlayBox || (_OverlayBox = /*#__PURE__*/_jsx(OverlayBox, {}))), /*#__PURE__*/_jsxs(RootStack, {
      alignItems: "center",
      "data-testid": "center-loader",
      direction: "column",
      spacing: "2rem",
      "data-element": "RootStack",
      "data-source-file": "CenterLoader.tsx",
      children: [_CircularProgress || (_CircularProgress = /*#__PURE__*/_jsx(CircularProgress, {
        "data-testid": "CircularProgress",
        size: 100,
        "data-element": "CircularProgress",
        "data-source-file": "CenterLoader.tsx"
      })), loaderText && /*#__PURE__*/_jsx(StyledTypography, {
        variant: "subtitle2",
        children: translate(loaderText, undefined, true)
      })]
    })]
  });
}
var StyledTypography = styled(Typography)(function () {
  return {
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: '1.758rem',
    textAlign: 'center'
  };
});
var RootStack = styled(Stack)(function () {
  return {
    left: '50%',
    position: 'fixed',
    top: '50%',
    transform: 'translate(-50%,-50%)',
    zIndex: 1
  };
});
var OverlayBox = styled(Box)(function () {
  return {
    height: 'calc(100vh - 100px)',
    left: '0',
    position: 'fixed',
    top: '6.25rem',
    width: '100%',
    zIndex: 1
  };
});